import { Btn, UL, LI, H6, H5, Image } from "../../../AbstractElements";
import React, { Fragment, useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Input,
  Col,
  Card,
  CardBody,
  InputGroup,
  Label,
  Media,
  Button,
  CardFooter,
} from "reactstrap";
import "rc-pagination/assets/index.css";
import "../../../assets/scss/index.less";
import * as queries from "../../../graphql/queries";
import * as mutations from "../../../graphql/mutations";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useForm } from "react-hook-form";
import awsExports from "../../../aws-exports";
import { useNavigate, useLocation, Link } from "react-router-dom";
import AWS from "aws-sdk";
import { H4 } from "../../../AbstractElements";
import {
  S3_BUCKET,
  REGION,
  CATEGORIES_FOLDER,
  SECRETACCESSKEY,
  ACCESSKEYID,
  limit,
} from "../../../Config/Config";
import { SiteContext } from "../../../App";
import SiteData from "../../../Data/Sites/index";
import CategoryData from "../../../Data/Category/index";
import AssetTemplate from "../../../Data/AssetTemplate/index";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const CategoriesListContain = () => {
  console.log("assetsCountBySite", CategoryData.getCategoryAssetCounts());
  const [assetsCountBySite, setAssetsCountBySite] = useState(
    CategoryData.getCategoryAssetCounts()
  );
  console.log("assets count", assetsCountBySite);
  const [categoryDetails, setCategoryDetails] = useState(
    CategoryData.getCategoryData()
  );
  const navigate = useNavigate();
  const state = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingassets, setIsLoadingassets] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [siteViewData, setSiteViewData] = useState([]);
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [categoryId, setCategoryId] = useState([]);
  const [serviceGroup, setServiceGroup] = useState([]);
  const countPerPage = 10;
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [collection, setCollection] = useState([]);
  const [totalCount, setTotalCount] = useState([]);
  const [siteDataList, setSites] = useState(SiteData.getSiteData());
  const [assetTemplates, setAssetTemplate] = useState(
    AssetTemplate.getAssetTemplate()
  );
  const LoginUserGroup = localStorage.getItem("groups");
  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);
  const globalSearch = (searchValue) => {
    setCurrentPage(1);
    const filteredData = categoryDetails.filter((item) => {
      const serviceGroup = getServiceGroup(item.servicegroupID) || "";
      return (
        item.categoryName
          ?.toLowerCase()
          .includes(searchValue.trim().toLowerCase()) ||
        serviceGroup.toLowerCase().includes(searchValue.trim().toLowerCase()) ||
        item.formDescription
          ?.toLowerCase()
          .includes(searchValue.trim().toLowerCase()) ||
        item.status?.toLowerCase().includes(searchValue.trim().toLowerCase())
      );
    });
    const configuredCollections = getConfiguredCollection(filteredData);
    console.log(configuredCollections);
    setCollection(configuredCollections);
  };

  useEffect(() => {
    try {
      if (assetsCountBySite.length > 0) {
        const totalAssetCount = assetsCountBySite.reduce(
          (accumulator, current) => {
            return accumulator + current.assetCount;
          },
          0
        );
        console.log(totalAssetCount);
        setTotalCount(totalAssetCount);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (!value) {
    } else {
      globalSearch(value);
    }
  }, [value]);

  const updatePage = (p, assetCounts) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    const configuredCollections = getConfiguredCollection(
      categoryDetails,
      assetCounts
    );
    console.log(configuredCollections);
    setCollection(configuredCollections);
  };

  const getConfiguredCollection = (filteredData, assetCounts) => {
    filteredData.forEach(async (data) => {
      console.log("imageURL", data?.imageURL);
      const filteredAssets = assetCounts.filter(
        (asset) => asset.categoriesID === data?.id
      );
      if (filteredAssets.length > 0) {
        let assetsCount = 0;
        filteredAssets.map((item, i) => {
          console.log("item.assetCount" + i, item.assetCount);
          assetsCount = assetsCount + item.assetCount;
        });
        data["assetsCount"] = assetsCount;
      } else {
        data["assetsCount"] = 0;
      }
      console.log("count Assets", data?.id + "-" + data["assetsCount"]);
      if (data?.imageURL?.length) {
        data["image"] = await getfilename(data?.imageURL);
      }
    });
    return filteredData;
  };

  useEffect(() => {
    try {
      console.log("siteDataList", siteDataList);
      console.log(limit);
      let filteredsites = [];
      if (selectedSiteGlobal) {
        filteredsites = siteDataList.filter(
          (item) => item.id === selectedSiteGlobal
        );
        console.log(filteredsites);
      } else if (state.state && state.state.site && state.state.site.id) {
        filteredsites = siteDataList.filter(
          (item) => item.id === state.state.site.id
        );
        console.log(filteredsites);
      } else {
        filteredsites = siteDataList;
      }
      if (filteredsites.length > 0) {
        const promises1 = filteredsites.map(async (item) => {
          return client.graphql({
            query: queries.assetCountsBySitedetailsID,
            variables: {
              sitedetailsID: item.id,
              limit: limit,
            },
          });
        });
        Promise.all(promises1).then(async (results) => {
          console.log(results);
          let assetCount = [];
          if (results.length > 0) {
            results.forEach((result1) => {
              if (result1.data.assetCountsBySitedetailsID !== null)
                if (result1.data.assetCountsBySitedetailsID.items.length > 0) {
                  let counts = result1.data.assetCountsBySitedetailsID;
                  if (counts !== null) {
                    if (counts.items.length > 0) {
                      counts.items.map((item) => {
                        assetCount.push(item);
                      });
                    }
                  }
                }
            });
            console.log(assetCount);
            if (assetCount.length > 0) {
              setAssetsCountBySite(assetCount);
              updatePage(1, assetCount);
            } else {
              setAssetsCountBySite(assetCount);
              updatePage(1, assetCount);
            }
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    siteDataList.length > 0,
    selectedSiteGlobal,
    state.state && state.state.site && state.state.site.id,
  ]);

  useEffect(() => {
    if (state.state) {
      console.log(state);
      setSiteViewData(state.state.site);
      let filteredSite = siteDataList.filter((item) => {
        return item.id === state.state.site.id;
      });
      setSites(filteredSite);
      console.log(filteredSite);
    }

    async function fetchServiceGroups() {
      await client
        .graphql({
          query: queries.listServiceGroups,
          authMode: "API_KEY",
          variables: {
            limit: limit,
          },
        })
        .then((result) => {
          const serviceGroups = result.data.listServiceGroups.items;
          console.log(serviceGroups);
          setServiceGroup(serviceGroups);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    fetchServiceGroups();
  }, []);

  // toggle
  const activeInactive = () => {
    setIsActive(!isActive);
  };

  const getServiceGroup = (id) => {
    const groupName = serviceGroup.filter((item) => {
      return item.id === id;
    });
    if (groupName.length > 0) {
      return groupName[0].serviceName;
    } else {
      return "";
    }
  };

  const cancelForm = () => {
    navigate(`${process.env.PUBLIC_URL}/sites`, {
      state: {
        category: state.state.category,
        site: state.state.site,
      },
    });
  };

  AWS.config.update({
    accessKeyId: ACCESSKEYID,
    secretAccessKey: SECRETACCESSKEY,
  });

  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  const getImage = async (filename) => {
    var params = {
      Bucket: S3_BUCKET,
      Key: `public/${CATEGORIES_FOLDER}/${filename}`,
    };
    try {
      const url = await myBucket.getSignedUrlPromise("getObject", params);
      return url;
    } catch (err) {
      return null;
    }
  };

  const getfilename = async (path) => {
    if (!path || path.trim() === "") {
      return null;
    }
    const files = JSON.parse(path);
    if (files.length > 0) {
      var newfilename = files[0].fileName;
      const imageUrl = await getImage(newfilename);
      return imageUrl;
    } else {
      return null;
    }
  };

  // const updateAssets = async () => {
  //   try {
  //     await client.graphql({
  //       query: queries.listAssets,
  //       authMode: "API_KEY",
  //       variables: {
  //         limit: 1000000,
  //         nextToken:
  //           "eyJ2ZXJzaW9uIjozLCJ0b2tlbiI6IkFnVjRMSVhqOUMyekJLMUtsODVSOFEwM1RDdTNYNDg5VTl6aEN2U1dualphaXZRQWV3QUNBQWRCY0hCVGVXNWpBQkZGYm1OeWVYQjBhVzl1UTI5dWRHVjRkQUFWWVhkekxXTnllWEIwYnkxd2RXSnNhV010YTJWNUFFUkJjV2hzTUVKSlpFTXhjbG94UkVWQk1HbzNkbFUxZERkd1NYWnZWVkJDZEdSc1FXVlpiRmN6TTJ4Vk9USnlWaTh2ZW1ZeE0wOTNXRFkzV1Vjd1IzVkVhbEU5UFFBQkFBZGhkM010YTIxekFGQmhjbTQ2WVhkek9tdHRjenBoY0MxemIzVjBhR1ZoYzNRdE1qb3pOak0zTVRjM09UUXpOelk2YTJWNUx6UXdNVGd5TnpJeUxXRmxNMlF0TkRsbE15MDRNVFV3TFRVMFlUWmxObVUwWWpka1lnQzRBUUlCQUhpZzRWTVpkWCtWV0ZNeE95T2FPbzI4RnB2SzlUUHdYc1NoWVNxOTVkeG9jd0dXZGxJSjRGSEZZc3hWem16VVIyT3JBQUFBZmpCOEJna3Foa2lHOXcwQkJ3YWdiekJ0QWdFQU1HZ0dDU3FHU0liM0RRRUhBVEFlQmdsZ2hrZ0JaUU1FQVM0d0VRUU00bDlDRllzeVBDTlhNMHZXQWdFUWdEdHFuUUFXMTEyYXpPUDllS2FYVlJSZU1QZjQxZnhSZHgzWXVILzQ1MllpbkVsOTRTYUxZSEIvSnN6Skd5V1dhdGRpWGxvcjRweHlENGd2d3dJQUFCQUF2L01HU0RuSGE2bjdJaTBoMDNDSFNVcDBOdFVtY3VtUDRYK0g5eFBoNmdmb2htWlA1QTFnR096MGc5NEV4UWJjLy8vLy93QUFBQUVBQUFBQUFBQUFBQUFBQUFFQUFBRzVKZkZwNlowNThtUFRaMTVIeS9aWjZhWldEMGNkeldqVm9udFVGZXk1MVAzVVArRXJ2M2Q3RzdSY2RBSGZ6Q3N6Q0dveEM2YnpVV2ZpdjU3b00rakw4NmRKSEZaeG5pUEROa2d0eFFXVjcrODNJaHUvSjF2SjFKU0YyeTYzdDBjbTVYL2g2UHE2Mzk2Z2xmN2s4UW9KenU4cm9NdmFUYTJNUEMzZlJXaXBDNWRHSThtWmNhaVljakpNeDNqYU9vY0NBTnQxNTZjMlhzSlZESFpUaW53aks4OFlOVit3Q0loSzdZZi9HZks3YkZTMXI1aXNDV05KVzFrSGNJUXFkVG8rK0hHWmlDR1JzWThmV0RKenQ1SmxPdVBMZm03Z1B3aFBTdHk0RzlLTXJrczBwN2FEc3NqUXJRbUhMSlJIdHdwOTA3OFEydnNUNTYxcjQ0QllXWDdOS3lMWFFCYkZiSnN4S2hyYVVIT2o3WVI1Y2xwQWVpN1F6K1M0ZUlzQndZYTJHSnYwOVVJdEdTS21DR2NobS9QWjlsRDUyRVU0ZWRQSkZCM1FrNzBTSXBnWHFhU3AzbTRhQ2lwcng2UTBQVUxWL2V6Y0RIVko1eHE3L3RrR1ljeDBLSUhSV2swRGdWd2I4R21jZU5IdWpxRWU4R3JEcnNBYldKS2dwbXBla0hoZFplRnU3ZWNGNisrRkMwcXFYVDVMcTdtL3VCOGYxMm1QY2Z5UjAxcmpRdjdLLzErMHRudVFEcWlJVnIwdnh1QnNGeFR2VnlVaGMzOEJVcEJhdEs5TjR1ZDE2Q0RMSGdmR3N3Qm5NR1VDTVFEc0N3dTdYdXZCVDJuenNFU2pEU0EycWF2cnlIRnNsbkRTcXk5S0FmSUtxWCtPcm1TT01ISnpFUTNZVGNraU91NENNRHp4N01oVHQraWpBazVYZ2JBWFZ3MUJ6T0l0VytxcVFjbHoyNHVZVXRJU0c3YTZxZGE2NHBJTmlsRnpwN1E1VXc9PSJ9eyJ2ZXJzaW9uIjozLCJ0b2tlbiI6IkFnVjQvaktreUhuU2szdWV0cE8wbzE1Wm5vY05iY0REZVFiYVpETzJMRjREZWRvQWV3QUNBQWRCY0hCVGVXNWpBQkZGYm1OeWVYQjBhVzl1UTI5dWRHVjRkQUFWWVhkekxXTnllWEIwYnkxd2RXSnNhV010YTJWNUFFUkJlbkJwWVZKNU5qQnZTVEV4WlVvMFZVdEZOV1o0VVROQ01tSmpObEV3VTFZMk4wZFVWVGRHV2sxc01rY3dRbWxaUzJ4WE5FSkNTM1ZTV2pnM1RWQTFSSGM5UFFBQkFBZGhkM010YTIxekFGQmhjbTQ2WVhkek9tdHRjenBoY0MxemIzVjBhR1ZoYzNRdE1qb3pOak0zTVRjM09UUXpOelk2YTJWNUx6UXdNVGd5TnpJeUxXRmxNMlF0TkRsbE15MDRNVFV3TFRVMFlUWmxObVUwWWpka1lnQzRBUUlCQUhpZzRWTVpkWCtWV0ZNeE95T2FPbzI4RnB2SzlUUHdYc1NoWVNxOTVkeG9jd0hNSkpvb3p1OTZXUDFhSS9Gb001SkFBQUFBZmpCOEJna3Foa2lHOXcwQkJ3YWdiekJ0QWdFQU1HZ0dDU3FHU0liM0RRRUhBVEFlQmdsZ2hrZ0JaUU1FQVM0d0VRUU13Y2R1L2ZMNjNrWVJRMmZGQWdFUWdEc3FQZGVqQ0QvM2dibldacVg3em0xYytQeVk1UHMrbk5RYWVVRVFnQ3pGaDhtbjVQaHNPaUVnRTNPV1lmcklWb3NRZSt1VjdxQ3N5aFBBWGdJQUFCQUFtTDlTL0MyZkpRK0Z5aHU0blRMNzIzN1g5Qll2Rnkwbmtuc0dzVFpYRVRmMHpsT1VKWjZ5TnJGei8yVjJ5d2lqLy8vLy93QUFBQUVBQUFBQUFBQUFBQUFBQUFFQUFBRzVMUU9tTTRaYjYrc2k1LzFjM1RkcjMvTHp0dmxsTVpXTFoyaTJIQ0dEdDJxRGVSOVg5VlJLVnpSaDN6ZE9mRmNURnNmU2RLaE5XMUN4L1BhV1NDaUZFbk00S0dKczRidHZyemxoQ2dTM0lSanh4M2xTclg5Q3hNZVRuazV4M2FYdXhCSjBiMmdMYzhTcFEvbnRrUGJlMklkWldwVWUzNFRFM1VvLzhEOVg2SzJHdWdSNE5BOUt0b3dEZWgrYzhRN0Yvck5sMCtTekhSMldXUi9LQVEzdnpGd1ozUS9BZFp0NmdLNSswTi9JdVd0ZmlYRWZFSmIrMTJNamZBN2VVUStMN3duVzhWWU9YMWRtMDN1bGkyQXZnaTltMzROL3ZLaFV0Qmg1UGVWTGFtTXpHZWY2UnBkc0t0bWRxdzdHcUVOcFU1MnhzWUtndVdsbGRrY1B1anRodHBGdkRBSFZlZWJGdDNrVnNUM3k0UWpheXNEL1VVRDRPdzFMUE9uck1KMllBeG5tem5OV29EWWk5ZU1oUGZYa3BsN1FickRlL2JSOTVoOGlDZERVblhKdTVmcTZXdDNYdjVpMVZEakVVenBORHE5US9FYnhnSys2VTk4ZGc4K2hwL2N3ZVhiWTRzSmR0UWg3WHk5dDY0V1gzUTdFd2o3R1hmM25TeW1PZTkwRW50REJ6OStOTTNHaW42R1dydG90bldKc01xQWkyYy9tZWQwR1g3QWZjM1JsazRkMnNseHRjbE1vcVVNUDFpTlVTZ2lNZzJRR2hJTm1JUldTVHZrM1Yzb2VjbFRVRklSck1RQm5NR1VDTVFDcEl5dFo4RVRMVlV5NzNQOHcrU2xrRWMreFpPOTR2S2g4UVdMVVRHWWJmZ2pLbDA2L2Zvb2RtdHdGeDJvNngvUUNNR3lwL3lBaDJXdmF3SWxlOTEzN0dFNkJGYkF2aHR3ZXdaSkZEbHJDTDdKdGtBelNaaVg1OENwdE03dy9XUE9maUE9PSJ9",
  //       },
  //     })
  //       .then(async (dataDetails) => {
  //         console.log("asset.count", dataDetails.data.listAssets.items.length);
  //         let nextToken = dataDetails.data.listAssets.nextToken;
  //         console.log("asset.nexttoken", dataDetails.data.listAssets.nextToken);
  //         dataDetails.data.listAssets.items.map(async (item) => {
  //           if (item.assetOwnerID !== null) {
  //             await client.graphql({
  //               query: queries.getSiteDetails,
  //               authMode: "API_KEY",
  //               variables: {
  //                 id: item.sitedetailsID,
  //               },
  //             }).then(async (sites) => {
  //               if (sites.data.getSiteDetails !== null) {
  //                 let site = sites.data.getSiteDetails;
  //                 console.log("site", site);
  //                 await client.graphql({
  //                   query: mutations.updateAssets,
  //                   authMode: "API_KEY",
  //                   variables: {
  //                     input: {
  //                       id: item.id,
  //                       assetOwnerID: site.assetownerID,
  //                     },
  //                   },
  //                 });
  //               }
  //             });
  //           }
  //         });
  //         // while (nextToken !== null) {
  //         //   await client.graphql({
  //         //     query: queries.listAssets,
  //         //     authMode: "API_KEY",
  //         //     variables: {
  //         //       limit: 1000000,
  //         //       nextToken: nextToken,
  //         //     },
  //         //   })
  //         //     .then((dataDetails) => {
  //         //       console.log(
  //         //         "asset.count",
  //         //         dataDetails.data.listAssets.items.length
  //         //       );
  //         //       nextToken = dataDetails.data.listAssets.nextToken;
  //         //       console.log(
  //         //         "asset.nexttoken loop",
  //         //         dataDetails.data.listAssets.nextToken
  //         //       );
  //         //       dataDetails.data.listAssets.items.map(async (item) => {
  //         //         if (item.assetOwnerID !== null) {
  //         //           await client.graphql({
  //         //             query: queries.getSiteDetails,
  //         //             authMode: "API_KEY",
  //         //             variables: {
  //         //               id: item.sitedetailsID,
  //         //             },
  //         //           }).then(async (sites) => {
  //         //             if (sites.data.getSiteDetails !== null) {
  //         //               let site = sites.data.getSiteDetails;
  //         //               console.log("site", site);
  //         //               await client.graphql({
  //         //                 query: mutations.updateAssets,
  //         //                 authMode: "API_KEY",
  //         //                 variables: {
  //         //                   input: {
  //         //                     id: item.id,
  //         //                     assetOwnerID: site.assetownerID,
  //         //                   },
  //         //                 },
  //         //               });
  //         //             }
  //         //           });
  //         //         }
  //         //       });
  //         //     })
  //         //     .catch((error) => {
  //         //       console.log(error);
  //         //     });
  //         // }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const renderList = (
    <Fragment>
      <Container fluid={true} className="ecommerce-dash">
        <br></br>
        <Col md="12" className="project-list">
          <Card className="custom-card">
            {/* <Row>
              <Col>
                <Btn attrBtn={{ color: "primary", onClick: updateAssets }}>
                  Update Assets
                </Btn>
              </Col>
            </Row> */}
            {/* <Row className="margin0">
              <Col md="4">
                <InputGroup>
                  <span className="input-group-text bg-transparent border-end-0">
                    <i className="icon-search"></i>
                  </span>
                  <Input
                    type="search"
                    placeholder="Search Category.."
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    className="border-start-0 border-end-0 py-3 ps-0"
                  />
                  <div className="input-group-text border-start-0 p-1 bg-transparent">
                    <Button color="primary" className="search-btn me-4">
                      Search
                    </Button>
                  </div>
                </InputGroup>
              </Col>
              <Col md="4">
                <div className="d-flex align-items-center justify-content-end h-100">
                  <p className={`mb-0 ${isActive && "fw-semibold"}`}>Active</p>
                  <Media body className="icon-stateCat switch-smcat px-2">
                    <Label className="switchCat mb-0">
                      <input type="checkbox" onClick={activeInactive} />
                      <span
                        className={
                          isActive
                            ? "switch-state bg-success"
                            : "switch-state bg-danger"
                        }
                      ></span>
                    </Label>
                  </Media>
                  <p className={`mb-0 ${!isActive && "fw-semibold"}`}>
                    Inactive
                  </p>
                </div>
              </Col>
              {state.state !== null &&
                state.state.site !== null &&
                state.state.category !== null && (
                  <Col md="4" className="text-end top6">
                    <Btn attrBtn={{ color: "primary", onClick: cancelForm }}>
                      Back
                    </Btn>
                  </Col>
                )}
            </Row> */}
          </Card>
          <br></br> <br></br>
          {/* <Row>          
            {state.state !== null &&
              state.state.site !== null &&
              state.state.category !== null && (
                <Col md="4" className="text-end">
                  <Btn attrBtn={{ color: "primary", onClick: cancelForm }}>
                    Back
                  </Btn>
                </Col>
              )}
          </Row> */}
          <Row>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                {collection.filter((item) =>
                  isActive
                    ? item.status === "Active"
                    : item.status === "Inactive"
                ).length > 0 ? (
                  <>
                    {collection &&
                      collection
                        .filter((catItem) =>
                          isActive
                            ? catItem.status === "Active"
                            : catItem.status === "Inactive"
                        )
                        .map((catItem) => (
                          <Col
                            sm="6"
                            xl="3"
                            lg="6"
                            className="xl-50 box-col-6"
                            key={catItem.id}
                          >
                            {state.state !== null && (
                              <Link
                                to={`${process.env.PUBLIC_URL}/sites/listsubcat`}
                                state={{
                                  category: catItem,
                                  site: siteViewData,
                                }}
                              >
                                <Card className="social-widget-card">
                                  <CardBody>
                                    <Media>
                                      <div className="social-font">
                                        <Image
                                          attrImage={{
                                            src: catItem.image, //`/assets/images/category/${catItem.image}`,
                                            alt: "",
                                          }}
                                        />
                                      </div>
                                    </Media>
                                  </CardBody>
                                  <CardFooter className="catFoot">
                                    <Row>
                                      <Col className="text-center">
                                        <H6
                                          attrH6={{
                                            className: "font-roboto",
                                          }}
                                        >
                                          {catItem.categoryName}
                                        </H6>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col className="text-center">
                                        <H6
                                          attrH6={{
                                            className: "font-roboto",
                                          }}
                                        >
                                          {getServiceGroup(
                                            catItem.servicegroupID
                                          )}
                                        </H6>
                                      </Col>
                                      <div className="col text-center">
                                        {catItem.categoryName !==
                                        "Thermal Imaging" ? (
                                          <>
                                            <H6>Assets Count:</H6>
                                            <H5
                                              attrH5={{
                                                className:
                                                  "counter mb-0 font-roboto font-primary mt-2",
                                              }}
                                            >
                                              {isLoadingassets
                                                ? "..."
                                                : catItem.assetsCount}
                                            </H5>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </Row>
                                  </CardFooter>
                                </Card>
                              </Link>
                              // <Link
                              //   to={`${process.env.PUBLIC_URL}/sites/listsubcat`}
                              //   state={{
                              //     category: catItem,
                              //     site: siteViewData,
                              //   }}
                              // >
                              //   <Card className="category-list rounded-2">
                              //     <img
                              //       className="card-img"
                              //       src={catItem.image}
                              //       alt={catItem.categoryName}
                              //     ></img>
                              //     <div className="card-img-overlay text-white p-0 overlay-dark">
                              //       <CardBody className="d-flex flex-column p-0 h-100">
                              //         <div className="d-flex justify-content-end">
                              //           <div
                              //             className={
                              //               catItem.status === "Active"
                              //                 ? "ribbon ribbon-clip-right ribbon-right ribbon-success"
                              //                 : "ribbon ribbon-clip-right ribbon-right ribbon-danger"
                              //             }
                              //           >
                              //             {catItem.status}
                              //           </div>
                              //         </div>
                              //         <div className="d-flex justify-content-between flex-column h-100">
                              //           <p className="activestatus text-white pt-4 pb-5">
                              //             {catItem.categoryName}
                              //           </p>
                              //           <Media className="static-widget">
                              //             <Media body>
                              //               <H4
                              //                 id="status"
                              //                 attrH6={{
                              //                   className: "font-roboto",
                              //                 }}
                              //               >
                              //                 {" "}
                              //                 {getServiceGroup(
                              //                   catItem.servicegroupID
                              //                 )}{" "}
                              //               </H4>

                              //               <H6>
                              //                 {catItem.categoryName !==
                              //                 "Thermal Imaging" ? (
                              //                   <H6>
                              //                     Assets Count:{" "}
                              //                     {isLoadingassets
                              //                       ? "..."
                              //                       : catItem.assetsCount}
                              //                   </H6>
                              //                 ) : (
                              //                   ""
                              //                 )}
                              //               </H6>
                              //             </Media>
                              //           </Media>
                              //         </div>
                              //       </CardBody>
                              //     </div>
                              //   </Card>
                              // </Link>
                            )}
                            {state.state === null && (
                              <Link
                                to={
                                  catItem.categoryName === "Thermal Imaging"
                                    ? `${process.env.PUBLIC_URL}/thermalReport`
                                    : `${process.env.PUBLIC_URL}/assets`
                                }
                                state={{
                                  category: catItem,
                                  assetCount: totalCount,
                                }}
                              >
                                <Card className="social-widget-card">
                                  <CardBody>
                                    <Media>
                                      <div className="social-font">
                                        <Image
                                          attrImage={{
                                            src: catItem.image, //`/assets/images/category/${catItem.image}`,
                                            alt: "",
                                          }}
                                        />
                                      </div>
                                    </Media>
                                  </CardBody>
                                  <CardFooter className="catFoot">
                                    <Row>
                                      <Col className="text-center">
                                        <H6
                                          attrH6={{
                                            className: "font-roboto",
                                          }}
                                        >
                                          {catItem.categoryName}
                                        </H6>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col className="text-center">
                                        <H6
                                          attrH6={{
                                            className: "font-roboto",
                                          }}
                                        >
                                          {getServiceGroup(
                                            catItem.servicegroupID
                                          )}
                                        </H6>
                                      </Col>
                                      <div className="col text-center">
                                        {catItem.categoryName !==
                                        "Thermal Imaging" ? (
                                          <>
                                            <H6>Assets Count:</H6>
                                            <H5
                                              attrH5={{
                                                className:
                                                  "counter mb-0 font-roboto font-primary mt-2",
                                              }}
                                            >
                                              {isLoadingassets
                                                ? "..."
                                                : catItem.assetsCount}
                                            </H5>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </Row>
                                  </CardFooter>
                                </Card>
                              </Link>

                              // <Link
                              //   to={
                              //     catItem.categoryName === "Thermal Imaging"
                              //       ? `${process.env.PUBLIC_URL}/thermalReport`
                              //       : `${process.env.PUBLIC_URL}/assets`
                              //   }
                              //   state={{
                              //     category: catItem,
                              //     assetCount: totalCount,
                              //   }}
                              // >
                              //   <Card className="category-list rounded-2">
                              //     <img
                              //       className="card-img"
                              //       src={catItem.image}
                              //       alt={catItem.categoryName}
                              //     ></img>
                              //     <div className="card-img-overlay text-white p-0 overlay-dark">
                              //       <CardBody className="d-flex flex-column p-0 h-100">
                              //         <div className="d-flex justify-content-end">
                              //           <div
                              //             className={
                              //               catItem.status === "Active"
                              //                 ? "ribbon ribbon-clip-right ribbon-right ribbon-success"
                              //                 : "ribbon ribbon-clip-right ribbon-right ribbon-danger"
                              //             }
                              //           >
                              //             {catItem.status}
                              //           </div>
                              //         </div>
                              //         <div className="d-flex justify-content-between flex-column h-100">
                              //           <p className="activestatus text-white pt-4 pb-5">
                              //             {catItem.categoryName}
                              //           </p>
                              //           <Media className="static-widget">
                              //             <Media body>
                              //               <H4
                              //                 id="status"
                              //                 attrH6={{
                              //                   className: "font-roboto",
                              //                 }}
                              //               >
                              //                 {" "}
                              //                 {getServiceGroup(
                              //                   catItem.servicegroupID
                              //                 )}{" "}
                              //               </H4>
                              //               <H6>
                              //                 {catItem.categoryName !==
                              //                 "Thermal Imaging" ? (
                              //                   <H6>
                              //                     Assets Count:{" "}
                              //                     {isLoadingassets
                              //                       ? "..."
                              //                       : catItem.assetsCount}
                              //                   </H6>
                              //                 ) : (
                              //                   ""
                              //                 )}
                              //               </H6>
                              //             </Media>
                              //           </Media>
                              //         </div>
                              //       </CardBody>
                              //     </div>
                              //   </Card>
                              // </Link>
                            )}
                          </Col>
                        ))}
                  </>
                ) : (
                  <p> No Category Found </p>
                )}
              </>
            )}
          </Row>
        </Col>
      </Container>
    </Fragment>
  );
  return (
    <div>
      {isLoading ? <LoadingSpinner /> : renderList}
      {errorMessage && <div className="error">{errorMessage}</div>}
    </div>
  );
};

export default CategoriesListContain;
